import { render, staticRenderFns } from "./UseCases.vue?vue&type=template&id=030f29f4&scoped=true&"
import script from "./UseCases.vue?vue&type=script&lang=js&"
export * from "./UseCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f29f4",
  null
  
)

export default component.exports